import { SearchOutlined } from '@ant-design/icons'
import { ConfigProvider, Input } from 'antd'
import type { SearchProps } from 'antd/es/input'
import classNames from 'classnames'

import cn from './AtomSearchInput.module.scss'

type SearchInputPropsType = Omit<SearchProps, 'enterButton'> & {
  isOrganisationSelected?: boolean
}

function AtomSearchInput({
  isOrganisationSelected = false,
  className,
  allowClear = true,
  ...restProps
}: SearchInputPropsType) {
  return (
    <ConfigProvider wave={{ disabled: true }}>
      <Input.Search
        {...restProps}
        allowClear={allowClear}
        enterButton={<SearchOutlined />}
        className={classNames(
          cn.searchInput,
          isOrganisationSelected && cn.searchInputSelected,
          className
        )}
      />
    </ConfigProvider>
  )
}

export default AtomSearchInput
